import { render, staticRenderFns } from "./DeviceRealBasicInfo.vue?vue&type=template&id=831c163a&scoped=true"
import script from "./DeviceRealBasicInfo.vue?vue&type=script&lang=js"
export * from "./DeviceRealBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceRealBasicInfo.vue?vue&type=style&index=0&id=831c163a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831c163a",
  null
  
)

export default component.exports